import React from 'react';
import { Popover } from 'antd-v5';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const BlacklistWarning = ({ blackListWords }) => {
  return (
    <div
      className="fs-12"
      style={{
        color: '#FF4D4F',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '17px',
        marginTop: '5px',
        gap: '5px',
      }}
    >
      <ExclamationCircleOutlined />
      <p style={{ margin: 0, display: 'flex', alignItems: 'center', width: '100%', gap: '4px' }}>
        You have used a{' '}
        <Popover
          content={
            <ul style={{ maxHeight: '200px', overflowY: 'scroll', margin: '0px' }}>
              {blackListWords?.map(word => (
                <li key={word} style={{ marginBottom: '5px' }}>
                  {word}
                </li>
              ))}
            </ul>
          }
          title="Blacklisted Words"
        >
          <div
            style={{
              textDecoration: 'underline',
            }}
          >
            blacklisted
          </div>
        </Popover>{' '}
        word. Please remove it to send the message.
      </p>
    </div>
  );
};

export default BlacklistWarning;
